import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import Title from "../Login/Components/title/title";
import profile from "../../assets/images/profile.png";
import "./Qualification.css";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import StartRating from "../../commons/StartRating";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";

class Qualification extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor() {
    super();

    this.currentIdTec = this.currentIdTec.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.consumerComments = this.consumerComments.bind(this);
    this.statusJob = this.statusJob.bind(this);

    this.state = {
      technician_name: "",
      urlPhotoProfileTechnician: "",
      calification: "",
      comments: "",
      rating: "",
    };
    
    this.currentIdTec();
    this.statusJob();
  }

  currentIdTec() {
    firebaseManager.currentIdTechnician(this.succesData);
  }

  succesData = (data) => {
    this.setState({
      technician_name: data.name,
      urlPhotoProfileTechnician: data.photoProfile,
    });
  };

  consumerComments() {
    firebaseManager.commentsConsumer(
      this.state.comments,
      this.successComments,
      this.failComments
    );
  }

  successComments = () => {
    window.location = "/home";
  };

  failComments(error) {
    alert(error.message);
  }

  statusJob() {
    firebaseManager.dentInProgress(this.successStatusDent);
  }

  successStatusDent = (dataStatus) => {
    if (dataStatus.status === "nfix") {
      let nfix = document.getElementById("nfix");
      nfix.classList.remove("d-none");
    }

    if (dataStatus.status === "fixed") {
      let complete = document.getElementById("complete");
      complete.classList.remove("d-none");
    }

    if (dataStatus.startCalification !== "" || dataStatus.comments !== "") {
      let nfix = document.getElementById("nfix");
      let complete = document.getElementById("complete");
      let qualification = document.getElementById("qualification");
      let qualificationStruc = document.getElementById("qualificationStruc");

      qualification.classList.remove("d-none");
      nfix.classList.add("d-none");
      complete.classList.add("d-none");
      qualificationStruc.classList.add("d-none");
    }
  };

  failSuccessStatus(error) {
    alert(error.message);
  }
  handleChange(e) {
    this.setState({
      comments: e.target.value,
    });
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="complete" className="d-none">
          <Title text1="Your Dent is completed!" />
        </div>
        <div id="nfix" className="d-none">
          <Title text1="Sorry! your Dent isn´t completed!" />
        </div>
        <div id="qualification" className="d-none">
          <Title text1="Thanks for your qualification!" />
        </div>
        <div
          id="qualificationStruc"
          className="container mt-5 mb-5 text-center"
        >
          <p>
            <b>How was your experience with {this.state.technician_name} ?</b>
          </p>
          <img
            src={this.state.urlPhotoProfileTechnician || profile}
            alt="profile"
            className="rounded-circle profileImgQualification mt-3"
          />
          <StartRating />
          <div className="mt-5">
            <form className="mt-3">
              <div className="form-group">
                <textarea
                  name="comments"
                  id="comments"
                  className="form-control txtAreaSize mx-auto"
                  placeholder="Comments"
                  onChange={this.handleChange}
                  value={this.state.comments}
                ></textarea>
              </div>
            </form>
            <div className="mb-5">
              <button
                onClick={this.consumerComments}
                className="btn btn-secondary mb-5"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}
export default Qualification;
